export const REQUIRED_FIELDS = "Email e senha são obrigatórios."
export const FAILED_TO_LOGIN = "Email ou senha inválidos."
export const UNAUTHORIZED_USER = "Você não tem autorização."

export const INVALID_PASSWORD =
  "A senha deve conter no mínimo 8 caracteres incluindo letras maiúsculas, números e caracteres especiais"
export const PASSWORDS_DONT_MATCH = "As senhas não conferem."
